import React from "react";
import { Tag } from 'antd';
// Components
import RowTools from "../../../../../components/Table/RowTools";
import Status from "../../../../../components/Table/Status/KetQuaQuanTrac"
// helper

const columns = ({ showEditModal, deleteRow, editable, showFile, showViewModal } = {}) => {
    var cl = [
        {
            // key: "",
            title: "#",
            dataIndex: "stt",
            width: "65px"
        },
        {
            // key: "",
            title: "Mã báo cáo",
            dataIndex: "maBaoCao",
            width: "15%"
        },
        {
            // key: "",
            title: "Tên báo cáo",
            dataIndex: "tenBaoCao",
            render: (value, row) => <span className="row-name" onClick={() => showViewModal(row, "view")}>{value}</span>,
        },
        {
            // key: "",
            title: "Đợt báo cáo",
            dataIndex: "dotBaoCao",
            width: "20%"
        },
        {
            // key: "",
            title: "Năm báo cáo",
            dataIndex: "namBaoCao",
            width: "15%"
        },
        {
            title: "Trạng thái",
            dataIndex: "ketQua_DanhGia",
            width: 130,
            render: (value, row) => (
                <div>
                    <Status value={value} trangthai={value} />
                </div>
            )
        },
        {
            key: "tools",
            title: "Thao tác",
            dataIndex: "tools",
            align: "center",
            width: "100px",
            fixed: 'right',
            render: (value, row) => (
                <RowTools
                    row={row}
                    iconDelete={editable ? false : true}
                    iconEdit={editable ? false : true}
                    showEditModal={() => showEditModal(row, "edit")}
                    deleteRowModal={() => deleteRow(row)}
                    iconFile={true}
                    showFile={showFile}
                />
            )
        }
    ];
    return cl.map(col => ({
        ...col,
    }));
};

export default columns;
